import {colors} from '../variables';
import {getMediaURL} from '../../utils/renderMedia';

export const imageBackgroundFields = [
  {
    name: 'media.src',
    label: 'Image',
    component: 'image',
    parse: (media) => `/${media.src}`,
    uploadDir: () => '/',
    previewSrc: (src) => getMediaURL(src),
    focusRing: false,
  },
  {
    name: 'media.parallax',
    component: 'toggle',
    label: 'Parallax',
    ignoreResponsive: true,
    description: 'Check to mark this to image as parallax effect.',
    toggleLabels: {
      true: 'On',
      false: 'Off',
    },
  },
  {
    name: 'media',
    label: 'Video',
    component: 'condition-group',
    condition: (value) => !value?.parallax,
    fields: [
      {
        component: 'select',
        name: 'backgroundSize',
        label: 'Background Size',
        options: [
          {label: 'auto', value: 'auto'},
          {label: 'cover', value: 'cover'},
          {label: 'contain', value: 'contain'}
        ],
      },
      {
        component: 'select',
        name: 'backgroundPosition',
        label: 'Background Position',
        options: ['inherit', 'center', 'top', 'right', 'bottom', 'left'],
      },
      {
        component: 'select',
        name: 'backgroundRepeat',
        label: 'Background Repeat',
        options: [
          {label: 'repeat', value: 'repeat'},
          {label: 'no-repeat', value: 'no-repeat'},
          {label: 'repeat-x', value: 'repeat-x'},
          {label: 'repeat-y', value: 'repeat-y'},
          {label: 'space', value: 'space'},
          {label: 'round', value: 'round'}
        ],
      }
    ]
  }

];
export const backgroundColor = {
  name: 'backgroundColor',
  label: 'Background Color',
  component: 'color',
  widget: 'block',
  colors
};
export const backgroundFields = [
  {
    name: '',
    label: '',
    component: 'responsive-group',
    fields: [
      backgroundColor,
      ...imageBackgroundFields
    ]
  }
];


export const background = {
  name: 'background',
  label: 'Background Settings',
  component: 'group',
  fields: backgroundFields
};
